<template>
  <div class="h-full overflow-hidden">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <div
      class="h-full w-[500%] [&>div]:w-[20%] relative duration-500 ease-in-out flex"
      :class="{
        'left-0': activeTabPosition == 0,
        'left-[calc(-100%*1)]': activeTabPosition == 1,
        'left-[calc(-100%*2)]': activeTabPosition == 2,
        'left-[calc(-100%*3)]': activeTabPosition == 3,
        'left-[calc(-100%*4)]': activeTabPosition == 4,
      }"
    >
      <div class="h-full relative">
        <div
          class="h-full duration-300"
          v-if="activeTabPosition == 0 || previousTab == 0"
          :class="{
            'opacity-0': loadedTab !== 0 || previousTab == 0,
            '!duration-[200ms]': previousTab == 0,
          }"
        >
          <div class="h-full overflow-auto" :key="'tab-0-' + tagsKey">
            <div class="py-2"></div>

            <div class="py-2 z-[2] relative">
              <WalletResume />
            </div>

            <div
              class="relative z-[2] px-6"
              v-if="userData.email == 'testtv@gmail.com'"
            >
              <div class="py-7"></div>
              <div class="font-bold text-3xl w-">Chaines de sport</div>
              <div class="py-1"></div>
              <div
                class="w-full relative py-[25%] rounded-content-md"
                @click="$Events.dispatchEvent('start_tv_required')"
              >
                <div class="w-full h-full absolute top-0 left-0 ripple">
                  <img
                    src="/images/tvs/footballPlayer.webp"
                    class="w-full h-full object-cover object-bottom"
                    alt=""
                  />
                </div>
                <div
                  class="absolute w-full h-full bg-gray-500 bg-opacity-50 top-0 left-0 flex items-center justify-center"
                  >
                  <div class="w-[5rem] h-[5rem] relative ">
                    <div
                      class="absolute w-full h-full bg-slate-300 bg-opacity-50 rounded-full p-6 animate-[outer-pulse_2s_ease-in-out_infinite]"
                    ></div>
                    <img
                      src="/images/play-button.svg"
                      class="w-full h-full object-cover object-center relative"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="py-5"></div>
            <div class="font-bold text-3xl px-6">Programmes des matches</div>
            <div class="py-0"></div>
            <Matches v-if="activeTabPosition == 0" />
            <!-- <div class="py-8"></div> -->
          </div>
        </div>
        <Loader
          class="h-full w-full absolute top-0 left-0"
          v-if="activeTabPosition == 0 && loadedTab !== 0"
        />
      </div>
      <div class="h-full relative">
        <div
          class="h-full duration-300"
          v-if="activeTabPosition == 1 || previousTab == 1"
          :class="{
            'opacity-0': loadedTab !== 1 || previousTab == 1,
            '!duration-[200ms]': previousTab == 1,
          }"
        >
          <div
            class="h-full overflow-auto"
            :key="'tab-1-' + tagsKey"
            id="couponsPageScrollableContainer"
          >
            <div class="sticky -top-8 z-[1] -skew-y-6">
              <div class="absolute w-full h-32 bodyBg"></div>
            </div>
            <div class="py-2"></div>
            <Publicities sallPubs displayCouponsPubs class="z-[2] relative" />
            <div class="py-8"></div>
            <Coupons />
            <div class="py-8"></div>
          </div>
        </div>
        <Loader
          class="h-full w-full absolute top-0 left-0"
          v-if="activeTabPosition == 1 && loadedTab !== 1"
        />
      </div>
      <div class="h-full relative">
        <div
          class="h-full duration-300 overflow-auto"
          v-if="activeTabPosition == 2 || previousTab == 2"
          :class="{
            'opacity-0': loadedTab !== 2 || previousTab == 2,
            '!duration-[200ms]': previousTab == 2,
          }"
        >
          <Publicities sallPubs />
          <div class="py-4"></div>
          <div class=" " id="servicesScroller" :key="'tab-2-' + tagsKey">
            <ServicesGroupNew v-if="userData.email == 'testtv@gmail.com'" />
            <ServicesGroup v-else />
          </div>
        </div>
        <Loader
          class="h-full w-full absolute top-0 left-0"
          v-if="activeTabPosition == 2 && loadedTab !== 2"
        />
      </div>
      <div class="h-full relative">
        <div
          class="h-full duration-300"
          v-if="activeTabPosition == 3 || previousTab == 3"
          :class="{
            'opacity-0': loadedTab !== 3 || previousTab == 3,
            '!duration-[200ms]': previousTab == 3,
          }"
        >
          <div class="h-[100%] overflow-hidden" :key="'tab-3-' + tagsKey">
            <TransactionList />
          </div>
        </div>
        <Loader
          class="h-full w-full absolute top-0 left-0"
          v-if="activeTabPosition == 3 && loadedTab !== 3"
        />
      </div>
      <div class="h-full relative">
        <div
          class="h-full duration-300"
          v-if="activeTabPosition == 4 || previousTab == 4"
          :class="{
            'opacity-0': loadedTab !== 4 || previousTab == 4,
            '!duration-[200ms]': previousTab == 4,
          }"
        >
          <div class="h-full overflow-auto" :key="'tab-4-' + tagsKey">
            <ProfileContent />
            <div class="py-8"></div>
          </div>
        </div>
        <Loader
          class="h-full w-full absolute top-0 left-0"
          v-if="activeTabPosition == 4 && loadedTab !== 4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/utils/Tabs.vue'
import Publicities from '@/components/appData/Publicities.vue'
import ServicesGroup from '@/components/transaction/ServicesGroup.vue'
import ServicesGroupNew from '@/components/transaction/ServicesGroup-new.vue'
import TransactionList from '../../transaction/TransactionList.vue'
import ProfileContent from '../../appData/ProfileContent.vue'
import Coupons from '../../appData/Coupons.vue'
import WalletResume from '../../appData/WalletResume.vue'
import Matches from '../../appData/Matches.vue'
import Loader from '@/components/utils/Loader.vue'
import UserProperty from '@/components/user/UserProperty.vue'

export default {
  name: 'home',
  components: {
    Tabs,
    Publicities,
    ServicesGroup,
    ServicesGroupNew,
    TransactionList,
    ProfileContent,
    Coupons,
    WalletResume,
    Matches,
    Loader,
    UserProperty,
  },
  data() {
    return {
      userData: {},
      tagsKey: 'initial',
      eventsIds: [],
      activeTabPosition: 2,
      previousTab: 'none',
      loadedTab: 'none',
      tabChangingTimeout: 'none',
      tabs: ['home', 'coupons', 'mainHome', 'transactions', 'profile'],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'home_tabs_navigation',
      this.onTabNavigation,
    )
    const id2 = this.$Events.handleEvent('lang_changed', () => {
      this.tagsKey = Date.now()
    })
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.tabChangingTimeout = setTimeout(() => {
      this.loadedTab = 2
    }, 1000)
  },
  methods: {
    onTabNavigation(data) {
      if (!data?.id) return
      const tabPosition = this.tabs.indexOf(data?.id)
      if (tabPosition < 0) {
        console.error('tab position not found for ', data)
        return
      }
      clearTimeout(this.tabChangingTimeout)
      this.previousTab = this.activeTabPosition
      this.activeTabPosition = tabPosition
      this.tabChangingTimeout = setTimeout(() => {
        this.loadedTab = tabPosition
        this.previousTab = 'none'
      }, 600)
    },
  },
}
</script>
